type ProviderComponent<T = unknown> = React.JSXElementConstructor<
  T & { children: React.ReactNode }
>;

type Props = {
  components: Array<ProviderComponent | [ProviderComponent<any>, Omit<any, 'children'>]>;
  children: React.ReactNode;
};

const Compose = (props: Props) => {
  const { components = [], children } = props;

  return components.reduceRight((acc, comp) => {
    if (Array.isArray(comp)) {
      const [Comp, props] = comp;
      return <Comp {...props}>{acc}</Comp>;
    } else {
      const Comp = comp;
      return <Comp>{acc}</Comp>;
    }
  }, children);
};

export default Compose;
